// extracted by mini-css-extract-plugin
export var downArrow = "_bf-0";
export var infoTooltipIcon = "_bf-3";
export var label = "_bf-1";
export var optionCard = "_bf-4";
export var upArrow = "_bf-2";